<template>
  <div class="modal fade" tabindex="-1" id="TissGuideModal"
       data-bs-keyboard="false" data-bs-backdrop="static">
    <div class="modal-dialog modal-xl">
      <form method="post" @submit.prevent="submitForm">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ guide?.id_tiss_guide ? 'Editar Guia' : 'Nova Guia' }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2"
                 @click="closeModal()"
                 data-bs-dismiss="modal" aria-label="Fechar">
              <i class="bi bi-x-lg"></i>
            </div>
          </div>

          <div class="modal-body">
            <div class="card shadow-sm border border-gray-200 mb-4">
              <div class="card-body py-4">
                <div class="row">
                  <div class="col-md-12">
                    <label class="fs-6 fw-bold mb-2 required">Tipo de Guia</label>
                    <select v-model="form.guide_type"
                            class="form-control form-control-solid"
                            required
                            @change="onGuideTypeChange">
                      <option value="">Selecione o tipo de guia</option>
                      <option value="CONSULTA">Consulta</option>
                      <option value="SP_SADT">Exames (SP/SADT)</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="form.guide_type" class="d-flex flex-column gap-4">

              <div class="card shadow-sm border border-gray-200">
                <div class="card-body py-4 px-4">
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <h6 class="fw-bold mb-0">Dados do Paciente</h6>
                  <button type="button"
                          class="btn btn-sm btn-light-primary"
                          @click="expandedSections.patientDetails = !expandedSections.patientDetails"
                          :data-bs-toggle="'collapse'"
                          :data-bs-target="'#patientDetailsCollapse'">
                    <i :class="expandedSections.patientDetails ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
                    <span class="ms-1">{{ expandedSections.patientDetails ? 'Ocultar' : 'Mostrar' }} detalhes</span>
                  </button>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="d-flex align-items-center justify-content-between mb-2">
                      <label class="fs-6 fw-bold mb-0 required">Paciente</label>
                      <a v-if="currentPatientId"
                         href="#"
                         title="Editar paciente"
                         @click.prevent="openModalEditPatient">
                        <i class="bi bi-pen"></i> Editar
                      </a>
                    </div>
                    <SearchPatient
                      v-model="form.patient_name"
                      :value="form.patient_name"
                      @onClick="onClickSearchedPatient"
                    />
                  </div>
                </div>
                <div v-if="form.patient_name" class="mt-2">
                  <small class="text-muted">
                    <i class="bi bi-person"></i> {{ form.patient_name }}
                    <span v-if="form.patient_cpf" class="ms-2"><i class="bi bi-card-text"></i> {{
                        form.patient_cpf
                      }}</span>
                    <span v-if="form.patient_birth_date" class="ms-2"><i
                      class="bi bi-calendar"></i> {{ formatDateToBR(form.patient_birth_date) }}</span>
                  </small>
                </div>
                <div class="collapse" :class="{ show: expandedSections.patientDetails }" id="patientDetailsCollapse">
                  <div class="row mt-2">
                    <div class="col-md-6">
                      <label class="fs-6 fw-bold mb-2">Nome do Paciente</label>
                      <input v-model="form.patient_name"
                             type="text"
                             class="form-control form-control-solid"
                             maxlength="255"
                             placeholder="Nome completo do paciente">
                    </div>
                    <div class="col-md-6">
                      <label class="fs-6 fw-bold mb-2">Nome Social</label>
                      <input v-model="form.patient_social_name"
                             type="text"
                             class="form-control form-control-solid"
                             maxlength="255"
                             placeholder="Nome social">
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-md-4">
                      <label class="fs-6 fw-bold mb-2">CPF</label>
                      <input v-model="form.patient_cpf"
                             v-mask="'###.###.###-##'"
                             type="text"
                             class="form-control form-control-solid"
                             placeholder="000.000.000-00">
                    </div>
                    <div class="col-md-4">
                      <label class="fs-6 fw-bold mb-2">Data de Nascimento</label>
                      <input
                        type="date"
                        class="form-control form-control-solid"
                        v-model="form.patient_birth_date"
                        placeholder="DD/MM/YYYY"
                      />
                    </div>
                    <div class="col-md-4">
                      <label class="fs-6 fw-bold mb-2">Número do Cartão do SUS</label>
                      <input v-model="form.patient_cns"
                             type="text"
                             class="form-control form-control-solid"
                             maxlength="20"
                             placeholder="Número do CNS">
                    </div>
                  </div>
                </div>
                </div>
              </div>

              <div class="card shadow-sm border border-gray-200">
                <div class="card-body py-4 px-4">
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <h6 class="fw-bold mb-0">Dados do Convênio</h6>
                  <button type="button"
                          class="btn btn-sm btn-light-primary"
                          @click="expandedSections.insuranceDetails = !expandedSections.insuranceDetails"
                          :data-bs-toggle="'collapse'"
                          :data-bs-target="'#insuranceDetailsCollapse'">
                    <i :class="expandedSections.insuranceDetails ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
                    <span class="ms-1">{{ expandedSections.insuranceDetails ? 'Ocultar' : 'Mostrar' }} detalhes</span>
                  </button>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <label class="fs-6 fw-bold mb-2">Convênio</label>
                    <Dropdown
                      :options="insurances"
                      v-model="selectedInsurance"
                      optionLabel="insurance_name"
                      optionValue="id_insurance"
                      :filter="true"
                      appendTo="self"
                      :filter-fields="['insurance_name', 'trading_name']"
                      empty-message="Nenhuma opção"
                      empty-filter-message="Nenhuma opção encontrada"
                      class="form-control form-control-solid w-full md:w-14rem form-control-sm"
                      placeholder="Selecione o convênio"
                      :showClear="true"
                      style="display: flex; padding: 0.35rem 0.75rem"
                      @change="onInsuranceChange"
                    />
                  </div>
                </div>
                <div v-if="form.plan_name || form.ans_registry" class="mt-2">
                  <small class="text-muted">
                    <i class="bi bi-heart-pulse"></i> {{ form.plan_name || 'Não informado' }}
                    <span v-if="form.ans_registry" class="ms-2"><i class="bi bi-hash"></i> ANS: {{ form.ans_registry }}</span>
                    <span v-if="form.card_number" class="ms-2"><i
                      class="bi bi-card-text"></i> Carteirinha: {{ form.card_number }}</span>
                  </small>
                </div>
                <div class="collapse" :class="{ show: expandedSections.insuranceDetails }"
                     id="insuranceDetailsCollapse">
                  <div class="row mt-2">
                    <div class="col-md-3">
                      <label class="fs-6 fw-bold mb-2">Código ANS</label>
                      <input v-model="form.ans_registry"
                             type="text"
                             class="form-control form-control-solid"
                             maxlength="10"
                             placeholder="Código ANS">
                    </div>
                    <div class="col-md-3">
                      <label class="fs-6 fw-bold mb-2">Nome do Plano</label>
                      <input v-model="form.plan_name"
                             type="text"
                             class="form-control form-control-solid"
                             maxlength="255"
                             placeholder="Nome do plano">
                    </div>
                    <div class="col-md-3">
                      <label class="fs-6 fw-bold mb-2">Número da Carteirinha</label>
                      <input v-model="form.card_number"
                             type="text"
                             v-mask="'#### #### #### #### ####'"
                             class="form-control form-control-solid"
                             maxlength="50"
                             placeholder="Número da carteirinha">
                    </div>
                    <div class="col-md-3">
                      <label class="fs-6 fw-bold mb-2">Validade da Carteirinha</label>
                      <input
                        type="date"
                        class="form-control form-control-solid"
                        v-model="form.card_validity_date"
                        placeholder="DD/MM/YYYY"
                      />
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-md-6">
                      <label class="fs-6 fw-bold mb-2">Número da Guia na Operadora</label>
                      <input v-model="form.operator_guide_number"
                             type="text"
                             class="form-control form-control-solid"
                             maxlength="100"
                             placeholder="Opcional">
                    </div>
                  </div>
                </div>
                </div>
              </div>

              <!-- Dados do Profissional Solicitante (SP/SADT) -->
              <div v-if="form.guide_type === 'SP_SADT'" class="card shadow-sm border border-gray-200">
                <div class="card-body py-4 px-4">
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <h6 class="fw-bold mb-0">Dados do Profissional Solicitante</h6>
                  <button type="button"
                          class="btn btn-sm btn-light-primary"
                          @click="expandedSections.requesterDetails = !expandedSections.requesterDetails"
                          :data-bs-toggle="'collapse'"
                          :data-bs-target="'#requesterDetailsCollapse'">
                    <i :class="expandedSections.requesterDetails ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
                    <span class="ms-1">{{ expandedSections.requesterDetails ? 'Ocultar' : 'Mostrar' }} detalhes</span>
                  </button>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <label class="fs-6 fw-bold mb-2 required">Profissional Solicitante</label>
                    <Dropdown
                      :options="professionals"
                      v-model="form.requester_professional_id"
                      optionLabel="prof_name"
                      optionValue="id_prof"
                      :filter="true"
                      appendTo="self"
                      empty-message="Nenhuma opção"
                      empty-filter-message="Nenhuma opção encontrada"
                      class="form-control form-control-solid w-full md:w-14rem form-control-sm"
                      placeholder="Selecione o profissional solicitante"
                      :showClear="true"
                      style="display: flex; padding: 0.35rem 0.75rem"
                      @change="onRequesterProfessionalChange"
                    />
                  </div>
                  <div class="col-md-6">
                    <label class="fs-6 fw-bold mb-2">Especialidade</label>
                    <Dropdown
                      :key="`requester-specialty-${form.requester_professional_id}-${requesterProfessionalSpecialties.length}`"
                      :options="requesterProfessionalSpecialties"
                      v-model="form.requester_id_spec"
                      optionLabel="spec_name"
                      optionValue="id_spec"
                      :filter="true"
                      appendTo="self"
                      empty-message="Nenhuma opção"
                      empty-filter-message="Nenhuma opção encontrada"
                      class="form-control form-control-solid w-full md:w-14rem form-control-sm"
                      placeholder="Selecione a especialidade"
                      :showClear="true"
                      :disabled="!form.requester_professional_id"
                      style="display: flex; padding: 0.35rem 0.75rem"
                      @change="onRequesterSpecialtyChange"
                    />
                  </div>
                </div>
                <div v-if="form.requester_professional_name" class="mt-2">
                  <small class="text-muted">
                    <i class="bi bi-person-badge"></i> {{ form.requester_professional_name || 'Não informado' }}
                    <span v-if="form.requester_professional_council" class="ms-2">
                      <i class="bi bi-award"></i> {{ form.requester_professional_council }}
                    </span>
                    <span v-if="form.requester_professional_cbo" class="ms-2">
                      <i class="bi bi-briefcase"></i> {{ form.requester_professional_cbo }}
                    </span>
                  </small>
                </div>
                <div class="row mt-2">
                  <div class="col-md-12">
                    <label class="fs-6 fw-bold mb-2">Indicação Clínica</label>
                    <input v-model="form.clinical_indication"
                           type="text"
                           class="form-control form-control-solid"
                           maxlength="255"
                           placeholder="Indicação clínica para os exames">
                  </div>
                </div>
                <div class="collapse" :class="{ show: expandedSections.requesterDetails }"
                     id="requesterDetailsCollapse">
                  <div class="row mt-2">
                    <div class="col-md-6">
                      <label class="fs-6 fw-bold mb-2">Conselho</label>
                      <Dropdown
                        :options="professionalCouncils"
                        v-model="form.requester_professional_council"
                        optionLabel="description"
                        optionValue="code"
                        :filter="true"
                        appendTo="self"
                        empty-message="Nenhuma opção"
                        empty-filter-message="Nenhuma opção encontrada"
                        class="form-control form-control-solid w-full md:w-14rem form-control-sm"
                        placeholder="Selecione o conselho"
                        :showClear="true"
                        style="display: flex; padding: 0.35rem 0.75rem"
                      />
                    </div>
                    <div class="col-md-6">
                      <label class="fs-6 fw-bold mb-2">CBO</label>
                      <Dropdown
                        :options="cbos"
                        v-model="form.requester_professional_cbo"
                        :optionLabel="(cbo) => `${cbo.cbo_code} - ${cbo.cbo_title}`"
                        optionValue="cbo_code"
                        :filter="true"
                        :filterFields="['cbo_code', 'cbo_title']"
                        appendTo="self"
                        empty-message="Nenhuma opção"
                        empty-filter-message="Nenhuma opção encontrada"
                        class="form-control form-control-solid w-full md:w-14rem form-control-sm"
                        placeholder="Selecione o CBO"
                        :showClear="true"
                        style="display: flex; padding: 0.35rem 0.75rem"
                      >
                        <template #option="slotProps">
                          <div>
                            <div class="fw-bold">{{ slotProps.option.cbo_code }}</div>
                            <small class="text-muted">{{ slotProps.option.cbo_title }}</small>
                          </div>
                        </template>
                      </Dropdown>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-md-6">
                      <label class="fs-6 fw-bold mb-2">Prestador Solicitante</label>
                      <input v-model="form.requester_provider_name"
                             type="text"
                             class="form-control form-control-solid"
                             maxlength="255"
                             placeholder="Nome da clínica/laboratório solicitante">
                    </div>
                    <div class="col-md-3">
                      <label class="fs-6 fw-bold mb-2">Código do Prestador</label>
                      <input v-model="form.requester_provider_code"
                             type="text"
                             class="form-control form-control-solid"
                             maxlength="50"
                             placeholder="Código na operadora">
                    </div>
                    <div class="col-md-3">
                      <label class="fs-6 fw-bold mb-2">Data da Solicitação</label>
                      <input
                        type="date"
                        class="form-control form-control-solid"
                        v-model="form.request_date"
                        placeholder="DD/MM/YYYY"
                      />
                    </div>
                  </div>
                </div>
                </div>
              </div>

              <!-- Dados do Profissional Executante -->
              <div class="card shadow-sm border border-gray-200">
                <div class="card-body py-4 px-4">
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <h6 class="fw-bold mb-0">Dados do Profissional Executante</h6>
                  <button type="button"
                          class="btn btn-sm btn-light-primary"
                          @click="expandedSections.professionalDetails = !expandedSections.professionalDetails"
                          :data-bs-toggle="'collapse'"
                          :data-bs-target="'#professionalDetailsCollapse'">
                    <i :class="expandedSections.professionalDetails ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
                    <span class="ms-1">{{
                        expandedSections.professionalDetails ? 'Ocultar' : 'Mostrar'
                      }} detalhes</span>
                  </button>
                </div>
                <div class="row">
                  <div :class="form.guide_type === 'SP_SADT' ? 'col-md-12' : 'col-md-6'">
                    <label class="fs-6 fw-bold mb-2">Profissional executante</label>
                    <Dropdown
                      :options="professionals"
                      v-model="form.id_prof"
                      optionLabel="prof_name"
                      optionValue="id_prof"
                      :filter="true"
                      appendTo="self"
                      empty-message="Nenhuma opção"
                      empty-filter-message="Nenhuma opção encontrada"
                      class="form-control form-control-solid w-full md:w-14rem form-control-sm"
                      placeholder="Opcional — se ainda não souber quem executará"
                      :showClear="true"
                      style="display: flex; padding: 0.35rem 0.75rem"
                      @change="onProfessionalChange"
                    />
                    <small class="text-muted d-block mt-1">Opcional. Em “Mostrar detalhes”, dá para preencher nome, conselho e CBO manualmente.</small>
                  </div>
                  <div v-if="form.guide_type !== 'SP_SADT'" class="col-md-6">
                    <label class="fs-6 fw-bold mb-2">Especialidade</label>
                    <Dropdown
                      :key="`specialty-${form.id_prof}-${professionalSpecialties.length}`"
                      :options="professionalSpecialties"
                      v-model="form.id_spec"
                      optionLabel="spec_name"
                      optionValue="id_spec"
                      :filter="true"
                      appendTo="self"
                      empty-message="Nenhuma opção"
                      empty-filter-message="Nenhuma opção encontrada"
                      class="form-control form-control-solid w-full md:w-14rem form-control-sm"
                      placeholder="Selecione a especialidade"
                      :showClear="true"
                      :disabled="!form.id_prof"
                      style="display: flex; padding: 0.35rem 0.75rem"
                      @change="onSpecialtyChange"
                    />
                  </div>
                </div>
                <div v-if="form.professional_name || form.professional_council" class="mt-2">
                  <small class="text-muted">
                    <i class="bi bi-person-badge"></i> {{ form.professional_name || 'Não informado' }}
                    <span v-if="form.professional_council" class="ms-2"><i
                      class="bi bi-award"></i> {{ form.professional_council }}</span>
                    <span v-if="form.professional_council_number" class="ms-2">{{
                        form.professional_council_number
                      }}</span>
                    <span v-if="form.professional_cbo" class="ms-2"><i
                      class="bi bi-briefcase"></i> {{ form.professional_cbo }}</span>
                  </small>
                </div>
                <div class="collapse" :class="{ show: expandedSections.professionalDetails }"
                     id="professionalDetailsCollapse">
                  <div class="row mt-2">
                    <div class="col-md-6">
                      <label class="fs-6 fw-bold mb-2">Nome do Profissional</label>
                      <input v-model="form.professional_name"
                             type="text"
                             class="form-control form-control-solid"
                             maxlength="255"
                             placeholder="Nome completo do profissional">
                    </div>
                    <div class="col-md-3">
                      <label class="fs-6 fw-bold mb-2">Conselho</label>
                      <Dropdown
                        :options="professionalCouncils"
                        v-model="form.professional_council"
                        optionLabel="description"
                        optionValue="code"
                        :filter="true"
                        appendTo="self"
                        empty-message="Nenhuma opção"
                        empty-filter-message="Nenhuma opção encontrada"
                        class="form-control form-control-solid w-full md:w-14rem form-control-sm"
                        placeholder="Selecione o conselho"
                        :showClear="true"
                        style="display: flex; padding: 0.35rem 0.75rem"
                      />
                    </div>
                    <div class="col-md-3">
                      <label class="fs-6 fw-bold mb-2">Número do Conselho</label>
                      <input v-model="form.professional_council_number"
                             type="text"
                             class="form-control form-control-solid"
                             maxlength="20"
                             placeholder="Número do conselho">
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-md-3">
                      <label class="fs-6 fw-bold mb-2">UF do Conselho</label>
                      <Dropdown
                        :options="states"
                        v-model="form.professional_council_state"
                        optionLabel="state_initials"
                        optionValue="state_initials"
                        :filter="true"
                        appendTo="self"
                        empty-message="Nenhuma opção"
                        empty-filter-message="Nenhuma opção encontrada"
                        class="form-control form-control-solid w-full md:w-14rem form-control-sm"
                        placeholder="Selecione o estado"
                        :showClear="true"
                        style="display: flex; padding: 0.35rem 0.75rem"
                      />
                    </div>
                    <div class="col-md-3">
                      <label class="fs-6 fw-bold mb-2">CBO</label>
                      <Dropdown
                        :options="cbos"
                        v-model="form.professional_cbo"
                        :optionLabel="(cbo) => `${cbo.cbo_code} - ${cbo.cbo_title}`"
                        optionValue="cbo_code"
                        :filter="true"
                        :filterFields="['cbo_code', 'cbo_title']"
                        appendTo="self"
                        empty-message="Nenhuma opção"
                        empty-filter-message="Nenhuma opção encontrada"
                        class="form-control form-control-solid w-full md:w-14rem form-control-sm"
                        placeholder="Selecione o CBO"
                        :showClear="true"
                        style="display: flex; padding: 0.35rem 0.75rem"
                      >
                        <template #option="slotProps">
                          <div>
                            <div class="fw-bold">{{ slotProps.option.cbo_code }}</div>
                            <small class="text-muted">{{ slotProps.option.cbo_title }}</small>
                          </div>
                        </template>
                      </Dropdown>
                    </div>
                  </div>
                </div>
                </div>
              </div>

              <div class="card shadow-sm border border-gray-200">
                <div class="card-body py-4 px-4">
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <h6 class="fw-bold mb-0">Dados do Prestador</h6>
                  <button type="button"
                          class="btn btn-sm btn-light-primary"
                          @click="expandedSections.providerDetails = !expandedSections.providerDetails"
                          :data-bs-toggle="'collapse'"
                          :data-bs-target="'#providerDetailsCollapse'">
                    <i :class="expandedSections.providerDetails ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
                    <span class="ms-1">{{ expandedSections.providerDetails ? 'Ocultar' : 'Mostrar' }} detalhes</span>
                  </button>
                </div>
                <div class="row mb-3">
                  <div class="col-md-12">
                    <label class="fs-6 fw-bold mb-2">Prestador executante</label>
                    <Dropdown
                      :options="suppliers"
                      v-model="providerSupplierId"
                      optionLabel="name"
                      optionValue="id"
                      :filter="true"
                      :filterFields="['name', 'document']"
                      appendTo="self"
                      empty-message="Nenhuma opção"
                      empty-filter-message="Nenhuma opção encontrada"
                      class="form-control form-control-solid w-full md:w-14rem form-control-sm"
                      placeholder="Buscar por nome ou documento..."
                      :showClear="true"
                      style="display: flex; padding: 0.35rem 0.75rem"
                      @change="onProviderSupplierChange"
                    >
                      <template #option="slotProps">
                        <div>
                          <div class="fw-bold">{{ slotProps.option.name }}</div>
                          <small class="text-muted">{{ slotProps.option.document || 'Sem documento' }}</small>
                        </div>
                      </template>
                    </Dropdown>
                    <small v-if="suppliersLoaded && suppliers.length === 0" class="text-muted d-block mt-1">
                      Nenhum fornecedor ativo disponível ou sem permissão para listar fornecedores.
                    </small>
                  </div>
                </div>
                <div v-if="form.provider_name" class="mb-2">
                  <small class="text-muted">
                    <i class="bi bi-building"></i> {{ form.provider_name }}
                    <span v-if="form.cnes" class="ms-2"><i class="bi bi-hash"></i> CNES: {{ form.cnes }}</span>
                  </small>
                </div>
                <div class="collapse" :class="{ show: expandedSections.providerDetails }" id="providerDetailsCollapse">
                  <div class="row">
                    <div class="col-md-4">
                      <label class="fs-6 fw-bold mb-2 required">CPF/CNPJ do Prestador</label>
                      <input v-model="form.provider_document"
                             v-mask="providerDocumentMask"
                             type="text"
                             class="form-control form-control-solid"
                             maxlength="20"
                             :disabled="true"
                             :placeholder="providerDocumentMask === '###.###.###-##' ? '000.000.000-00' : '00.000.000/0000-00'">
                    </div>
                    <div class="col-md-6">
                      <label class="fs-6 fw-bold mb-2 required">Nome do Prestador</label>
                      <input v-model="form.provider_name"
                             type="text"
                             class="form-control form-control-solid"
                             maxlength="255"
                             :disabled="true"
                             placeholder="Nome do prestador">
                    </div>
                    <div class="col-md-2">
                      <label class="fs-6 fw-bold mb-2">CNES</label>
                      <input v-model="form.cnes"
                             type="text"
                             class="form-control form-control-solid"
                             maxlength="10"
                             :disabled="true"
                             placeholder="Código CNES">
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-md-3">
                      <label class="fs-6 fw-bold mb-2">CEP</label>
                      <div class="input-group">
                        <input v-model="form.provider_zipcode"
                               v-mask="'#####-###'"
                               type="text"
                               class="form-control form-control-solid"
                               maxlength="10"
                               placeholder="00000-000"
                               readonly="true"
                               @blur="searchZipcode">
                        <button class="btn btn-icon btn-light-primary"
                                type="button"
                                @click="searchZipcode"
                                readonly="true"
                                :disabled="loadingZipcode">
                          <i v-if="loadingZipcode" class="bi bi-arrow-repeat spinner spinner-sm"></i>
                          <i v-else class="bi bi-search"></i>
                        </button>
                      </div>
                    </div>
                    <div class="col-md-5">
                      <label class="fs-6 fw-bold mb-2">Endereço</label>
                      <input v-model="form.provider_address"
                             type="text"
                             class="form-control form-control-solid"
                             maxlength="255"
                             :disabled="true"
                             placeholder="Endereço completo">
                    </div>
                    <div class="col-md-2">
                      <label class="fs-6 fw-bold mb-2">Número</label>
                      <input v-model="form.provider_number"
                             type="text"
                             class="form-control form-control-solid"
                             maxlength="20"
                             :disabled="true"
                             placeholder="Número">
                    </div>
                    <div class="col-md-2">
                      <label class="fs-6 fw-bold mb-2">Complemento</label>
                      <input v-model="form.provider_complement"
                             type="text"
                             class="form-control form-control-solid"
                             maxlength="100"
                             :disabled="true"
                             placeholder="Complemento">
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-md-3">
                      <label class="fs-6 fw-bold mb-2">Bairro</label>
                      <input v-model="form.provider_neighborhood"
                             type="text"
                             class="form-control form-control-solid"
                             maxlength="100"
                             readonly="true"
                             placeholder="Bairro">
                    </div>
                    <div class="col-md-3">
                      <label class="fs-6 fw-bold mb-2">Estado</label>
                      <Dropdown
                        :options="states"
                        v-model="form.id_provider_state"
                        optionLabel="state_name"
                        optionValue="id_state"
                        :filter="true"
                        appendTo="self"
                        empty-message="Nenhuma opção"
                        empty-filter-message="Nenhuma opção encontrada"
                        class="form-control form-control-solid w-full md:w-14rem form-control-sm"
                        placeholder="Selecione o estado"
                        :showClear="true"
                        style="display: flex; padding: 0.35rem 0.75rem"
                        :disabled="true"
                        @change="onProviderStateChange"
                      />
                    </div>
                    <div class="col-md-3">
                      <label class="fs-6 fw-bold mb-2">Cidade</label>
                      <Dropdown
                        :options="providerCities"
                        v-model="form.id_provider_city"
                        optionLabel="city_name"
                        optionValue="id_city"
                        :filter="true"
                        appendTo="self"
                        empty-message="Nenhuma opção"
                        empty-filter-message="Nenhuma opção encontrada"
                        class="form-control form-control-solid w-full md:w-14rem form-control-sm"
                        placeholder="Selecione a cidade"
                        :showClear="true"
                        style="display: flex; padding: 0.35rem 0.75rem"
                        :disabled="true"
                      />
                    </div>
                  </div>
                </div>
                </div>
              </div>

              <TissConsultationGuideForm
                v-if="form.guide_type === 'CONSULTA'"
                :form="form"
                :expanded-sections="expandedSections"
                :consultation-types="consultationTypes"
                :attendance-regimes="attendanceRegimes"
                :accident-indicators="accidentIndicators"
                :format-currency="formatCurrency"
              />

              <template v-if="form.guide_type === 'CONSULTA'">
                <div class="card shadow-sm border border-gray-200">
                  <div class="card-body py-4 px-4">
                    <label class="fs-6 fw-bold mb-2">Observações</label>
                    <textarea
                      v-model="form.observations"
                      class="form-control form-control-solid"
                      rows="6"
                      placeholder="Observações sobre a guia (opcional)"
                    />
                  </div>
                </div>
              </template>

              <TissSpSadtGuideForm
                v-if="form.guide_type === 'SP_SADT'"
                :form="form"
                :procedures="form.executed_procedures"
                :other-expenses="form.other_expenses"
                :total-procedures-value="getTotalProceduresValue()"
                :total-expenses-value="getTotalExpensesValue()"
                :format-currency="formatCurrency"
                :format-date-to-b-r="formatDateToBR"
                :get-expense-type-label="getExpenseTypeLabel"
                @add-procedure="openProcedureModal()"
                @edit-procedure="editProcedure"
                @remove-procedure="removeProcedure"
                @add-expense="openExpenseModal()"
                @edit-expense="editExpense"
                @remove-expense="removeExpense"
                @update-attachments="onUpdateAttachments"
              />

            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal()">Cancelar</button>
            <button type="submit" class="btn btn-primary" :disabled="loading">
              <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
              {{ guide?.id_tiss_guide ? 'Atualizar' : 'Salvar' }}
            </button>
          </div>
        </div>
      </form>
    </div>

    <!-- Modal para Adicionar/Editar Procedimento -->
    <div class="modal fade" tabindex="-1" id="ProcedureModal" data-bs-keyboard="false" data-bs-backdrop="static">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{
                editingProcedureIndex !== null ? 'Editar Procedimento' : 'Adicionar Procedimento'
              }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeProcedureModal"
                 data-bs-dismiss="modal">
              <i class="bi bi-x-lg"></i>
            </div>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-4">
                <label class="fs-6 fw-bold mb-2 required">Código do Procedimento</label>
                <InputSearchProcedure
                  :model-value="procedureForm.code"
                  @update:model-value="onProcedureFormCodeChange"
                  :place-id="place?.id_place"
                  :use-place-catalog="true"
                  list-max-height="min(65vh, 520px)"
                  placeholder="Buscar nos exames/procedimentos cadastrados..."
                  @on-select="onProcedureSelectInModal"
                />
              </div>
              <div class="col-md-2">
                <label class="fs-6 fw-bold mb-2 required">Tabela</label>
                <input v-model="procedureForm.table_code" type="text" class="form-control form-control-solid" required
                       maxlength="10" placeholder="Ex: 22">
              </div>
              <div class="col-md-6">
                <label class="fs-6 fw-bold mb-2 required">Descrição</label>
                <input v-model="procedureForm.description" type="text" class="form-control form-control-solid" required
                       maxlength="255" placeholder="Descrição do procedimento">
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-4">
                <label class="fs-6 fw-bold mb-2">Quantidade</label>
                <input v-model.number="procedureForm.quantity" type="number" min="1" step="1"
                       class="form-control form-control-solid">
              </div>
              <div class="col-md-4">
                <label class="fs-6 fw-bold mb-2">Valor Unitário</label>
                <money3
                  v-model="procedureForm.unit_value"
                  class="form-control form-control-solid"
                  v-bind="money3Config"
                />
              </div>
              <div class="col-md-4">
                <label class="fs-6 fw-bold mb-2 required">Repasse unitário</label>
                <money3
                  v-model="procedureForm.unit_transfer_value"
                  class="form-control form-control-solid"
                  required
                  v-bind="money3Config"
                />
              </div>
            </div>
            <div class="row mt-2" v-if="procedureForm.quantity && procedureForm.unit_value">
              <div class="col-md-12">
                <div class="alert alert-info mb-0">
                  <strong>Total:</strong> R$ {{
                    formatCurrency(procedureForm.unit_value * procedureForm.quantity * (procedureForm.reduction_factor || 1.0))
                  }}
                </div>
              </div>
            </div>
            <div class="mt-3">
              <button type="button"
                      class="btn btn-sm btn-light-primary"
                      @click="procedureModalDetailsExpanded = !procedureModalDetailsExpanded">
                <i :class="procedureModalDetailsExpanded ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
                <span class="ms-1">{{ procedureModalDetailsExpanded ? 'Ocultar' : 'Mostrar' }} detalhes</span>
              </button>
            </div>
            <div v-show="procedureModalDetailsExpanded" class="mt-2">
              <div class="row mt-2">
                <div class="col-md-4">
                  <label class="fs-6 fw-bold mb-2">Data de Execução</label>
                  <input
                    type="date"
                    class="form-control form-control-solid"
                    v-model="procedureForm.execution_date"
                    placeholder="DD/MM/YYYY"
                  />
                </div>
                <div class="col-md-4">
                  <label class="fs-6 fw-bold mb-2">Hora Início</label>
                  <input v-model="procedureForm.start_time" type="time" class="form-control form-control-solid">
                </div>
                <div class="col-md-4">
                  <label class="fs-6 fw-bold mb-2">Hora Fim</label>
                  <input v-model="procedureForm.end_time" type="time" class="form-control form-control-solid">
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-md-4">
                  <label class="fs-6 fw-bold mb-2">Fator de Redução</label>
                  <input v-model.number="procedureForm.reduction_factor" type="number" min="0" max="1" step="0.01"
                         class="form-control form-control-solid" value="1.0">
                  <small class="text-muted">Padrão: 1.0</small>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeProcedureModal">Cancelar</button>
            <button type="button" class="btn btn-light-primary" @click="saveProcedure(true)">Salvar e continuar</button>
            <button type="button" class="btn btn-primary" @click="saveProcedure(false)">Salvar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal para Adicionar/Editar Despesa -->
    <div class="modal fade" tabindex="-1" id="ExpenseModal" data-bs-keyboard="false" data-bs-backdrop="static">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ editingExpenseIndex !== null ? 'Editar Despesa' : 'Adicionar Despesa' }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeExpenseModal"
                 data-bs-dismiss="modal">
              <i class="bi bi-x-lg"></i>
            </div>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-4">
                <label class="fs-6 fw-bold mb-2 required">Tipo de Despesa</label>
                <select v-model="expenseForm.expense_code" class="form-control form-control-solid" required>
                  <option value="">Selecione</option>
                  <option value="01">01 - Diárias</option>
                  <option value="02">02 - Medicamentos</option>
                  <option value="03">03 - Materiais</option>
                  <option value="05">05 - Taxas e Aluguéis</option>
                  <option value="07">07 - Gases Medicinais</option>
                  <option value="08">08 - Órteses, Próteses e Materiais Especiais</option>
                </select>
              </div>
              <div class="col-md-4">
                <label class="fs-6 fw-bold mb-2 required">Data de Execução</label>
                <input
                  type="date"
                  class="form-control form-control-solid"
                  v-model="expenseForm.execution_date"
                  placeholder="DD/MM/YYYY"
                  required
                />
              </div>
              <div class="col-md-2">
                <label class="fs-6 fw-bold mb-2">Hora Início</label>
                <input v-model="expenseForm.start_time" type="time" class="form-control form-control-solid">
              </div>
              <div class="col-md-2">
                <label class="fs-6 fw-bold mb-2">Hora Fim</label>
                <input v-model="expenseForm.end_time" type="time" class="form-control form-control-solid">
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-3">
                <label class="fs-6 fw-bold mb-2 required">Tabela</label>
                <input v-model="expenseForm.table_code" type="text" class="form-control form-control-solid" required
                       maxlength="10" placeholder="Ex: 22">
              </div>
              <div class="col-md-3">
                <label class="fs-6 fw-bold mb-2 required">Código do Item</label>
                <input v-model="expenseForm.item_code" type="text" class="form-control form-control-solid" required
                       maxlength="20" placeholder="Código do item">
              </div>
              <div class="col-md-6">
                <label class="fs-6 fw-bold mb-2 required">Descrição</label>
                <input v-model="expenseForm.item_description" type="text" class="form-control form-control-solid"
                       required maxlength="255" placeholder="Descrição do item">
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-3">
                <label class="fs-6 fw-bold mb-2 required">Quantidade</label>
                <input v-model.number="expenseForm.quantity" type="number" min="0" step="0.01"
                       class="form-control form-control-solid" required>
              </div>
              <div class="col-md-3">
                <label class="fs-6 fw-bold mb-2 required">Unidade de Medida</label>
                <input v-model="expenseForm.unit_measure" type="text" class="form-control form-control-solid" required
                       maxlength="10" placeholder="Ex: 036">
                <small class="text-muted">036 = Unidade</small>
              </div>
              <div class="col-md-3">
                <label class="fs-6 fw-bold mb-2 required">Valor Unitário</label>
                <money3
                  v-model="expenseForm.unit_value"
                  class="form-control form-control-solid"
                  required
                  v-bind="money3Config"
                />
              </div>
              <div class="col-md-3">
                <label class="fs-6 fw-bold mb-2">Total</label>
                <input :value="formatCurrency(expenseForm.quantity * expenseForm.unit_value)" type="text"
                       class="form-control form-control-solid" readonly>
              </div>
            </div>
            <div class="row mt-2" v-if="expenseForm.expense_code === '02'">
              <div class="col-md-6">
                <label class="fs-6 fw-bold mb-2">Registro ANVISA</label>
                <input v-model="expenseForm.anvisa_registration" type="text" class="form-control form-control-solid"
                       maxlength="50" placeholder="Registro ANVISA (medicamentos)">
              </div>
              <div class="col-md-6">
                <label class="fs-6 fw-bold mb-2">Referência do Fabricante</label>
                <input v-model="expenseForm.manufacturer_reference" type="text" class="form-control form-control-solid"
                       maxlength="50" placeholder="Referência do fabricante">
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeExpenseModal">Cancelar</button>
            <button type="button" class="btn btn-light-primary" @click="saveExpense(true)">Salvar e continuar</button>
            <button type="button" class="btn btn-primary" @click="saveExpense(false)">Salvar</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ModalPatient
    v-if="currentPatientData"
    :patient="currentPatientData"
    :open-modal="isEditPatientModalOpen"
    :key="'modal-patient-' + currentPatientData?.id_patient"
    @onCloseModal="onCloseModalEditPatient"
    @onPatientUpdated="onPatientUpdated"
  />

  <TissGuideChargeActionsModal
    ref="chargeActionsModal"
    :guideId="chargeActionsGuideId"
    :chargeData="chargeActionsChargeData"
    :defaultEmail="form?.patient_email || ''"
    @viewPix="onViewPixFromChargeActions"
  />

  <PixPaymentModal
    ref="pixPaymentModal"
    :pixData="pixModalData"
    @onClose="pixModalData = null"
  />
</template>

<script>
import http from "@/helpers/http";
import Alert from "@/helpers/alert";
import Modal from "@/helpers/modal";
import SearchPatient from "@/components/SearchPatient.vue";
import ModalPatient from "../patient/ModalPatient.vue";
import PixPaymentModal from "@/components/PixPaymentModal.vue";
import Dropdown from "primevue/dropdown";
import {mask} from "vue-the-mask";
import TissConsultationGuideForm from "./components/TissConsultationGuideForm.vue";
import TissSpSadtGuideForm from "./components/TissSpSadtGuideForm.vue";
import InputSearchProcedure from "@/components/InputSearchProcedure.vue";
import Download from "@/helpers/download";
import Loader from "@/helpers/loader";
import TissGuideChargeActionsModal from "@/components/TissGuideChargeActionsModal.vue";
import { toPixQrCodeDataUrl } from "@/helpers/pixQrCode";
import { Money3Component } from "v-money3";

export default {
  name: "TissGuideModal",
  components: {
    SearchPatient,
    Dropdown,
    TissConsultationGuideForm,
    TissSpSadtGuideForm,
    InputSearchProcedure,
    ModalPatient,
    TissGuideChargeActionsModal,
    PixPaymentModal,
    money3: Money3Component,
  },
  directives: {
    mask,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    guide: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      defaultProcedureCode: '10101012',
      loading: false,
      loadingZipcode: false,
      currentPatientData: null,
      isEditPatientModalOpen: false,
      insurances: [],
      cbos: [],
      professionalCouncils: [],
      attendanceRegimes: [],
      accidentIndicators: [],
      states: [],
      providerCities: [],
      specialties: [],
      professionalSpecialties: [],
      requesterProfessionalSpecialties: [],
      consultationTypes: [],
      suppliers: [],
      suppliersLoaded: false,
      providerSupplierId: null,
      _applyingProcedureSuggestion: false,
      _resolveProcedureDebounce: null,
      _suspendResolvedProcedureFetch: false,
      editingProcedureIndex: null,
      editingExpenseIndex: null,
      procedureModalDetailsExpanded: false,
      spSadtAttachments: [],
      expandedSections: {
        patientDetails: false,
        insuranceDetails: false,
        requesterDetails: false,
        professionalDetails: false,
        providerDetails: false,
        procedureDetails: false,
        consultationDetails: false,
      },
      procedureForm: {
        code: '',
        table_code: '22',
        description: '',
        execution_date: '',
        start_time: '',
        end_time: '',
        quantity: 1,
        unit_value: 0,
        unit_transfer_value: 0,
        reduction_factor: 1.0,
        catalog_spec_id: null,
      },
      expenseForm: {
        expense_code: '',
        execution_date: '',
        start_time: '',
        end_time: '',
        table_code: '22',
        item_code: '',
        item_description: '',
        quantity: 0,
        unit_measure: '036',
        unit_value: 0,
        anvisa_registration: '',
        manufacturer_reference: '',
      },
      form: {
        guide_type: '',
        id_patient: null,
        patient_name: '',
        id_prof: null,
        id_insurance: null,
        operator_guide_number: '',
        ans_registry: '',
        plan_name: '',
        card_number: '',
        card_validity_date: '',
        patient_social_name: '',
        patient_cpf: '',
        patient_birth_date: '',
        patient_cns: '',
        provider_document: '',
        provider_name: '',
        provider_address: '',
        provider_number: '',
        provider_complement: '',
        provider_neighborhood: '',
        id_provider_city: null,
        id_provider_state: null,
        provider_zipcode: '',
        cnes: '',
        professional_name: '',
        professional_council: '',
        professional_council_number: '',
        professional_council_state: '',
        professional_cbo: '',
        attendance_date: this.dateToString(new Date()),
        procedure_code: this.defaultProcedureCode,
        procedure_table: '22',
        procedure_value: 0,
        procedure_transfer_value: 0,
        id_spec: null,
        emission_date: this.dateToString(new Date()),
        observations: '',
        consultation_type: '1',
        accident_indicator: '9',
        newborn_care: 'N',
        special_coverage: '',
        attendance_regime: '01',
        occupational_health: '',
        authorization_number: '',
        authorization_password: '',
        authorization_validity: '',
        requester_professional_id: null,
        requester_professional_name: '',
        requester_professional_council: '',
        requester_professional_cbo: '',
        requester_id_spec: null,
        requester_provider_code: '',
        requester_provider_name: '',
        request_date: '',
        clinical_indication: '',
        executed_procedures: [],
        other_expenses: [],
      },
      chargeActionsGuideId: null,
      chargeActionsChargeData: null,
      pixModalData: null,
      money3Config: {
        masked: false,
        prefix: "R$ ",
        suffix: "",
        thousands: ".",
        decimal: ",",
        precision: 2,
        disableNegative: true,
        disabled: false,
        min: null,
        max: null,
        allowBlank: false,
        minimumNumberOfCharacters: 0,
        shouldRound: false,
        focusOnRight: false,
      },
    };
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
    currentPatientId() {
      return this.form?.id_patient || null;
    },
    selectedInsurance: {
      get() {
        const value = this.form.id_insurance;
        if (value === null || value === undefined || value === '') {
          return null;
        }
        const insurance = this.insurances.find(i => i.id_insurance == value);
        return insurance ? insurance.id_insurance : value;
      },
      set(value) {
        this.form.id_insurance = value;
      },
    },
    professionals() {
      return this.$store.state.auth.professionals || [];
    },
    selectedRequesterCbo: {
      get() {
        return this.form.requester_professional_cbo;
      },
      set(value) {
        this.form.requester_professional_cbo = value;
      },
    },
    providerDocumentMask() {
      const digits = (this.form.provider_document || '').replace(/\D/g, '');
      return digits.length <= 11 ? '###.###.###-##' : '##.###.###/####-##';
    },
    isEditingGuide() {
      return Boolean(this.guide && this.guide.id_tiss_guide);
    },
  },
  watch: {
    show(newValue) {
      if (newValue) {
        this.loadInsurances();
        this.loadSuppliers();
        this.loadCbos();
        this.loadProfessionalCouncils();
        this.loadAttendanceRegimes();
        this.loadAccidentIndicators();
        this.loadStates();
        this.loadSpecialties();
        this.loadConsultationTypes();

        setTimeout(() => {
          if (this.guide && this.guide.id_tiss_guide) {
            this.loadGuideData();
          } else {
            this.resetForm();
            this.form.emission_date = this.dateToString(new Date());
          }
          Modal.toggle('#TissGuideModal');
        }, 100);
      }
    },
    guide: {
      handler(newGuide, oldGuide) {
        if (newGuide && newGuide.id_tiss_guide && this.show && newGuide.id_tiss_guide !== oldGuide?.id_tiss_guide) {
          this.$nextTick(() => {
            this.loadGuideData();
          });
        }
      },
      immediate: false,
      deep: true,
    },
    'form.guide_type'(newVal, oldVal) {
      if (newVal === 'CONSULTA' && oldVal !== 'CONSULTA' && !this.isEditingGuide) {
        this.$nextTick(() => this.fetchResolvedProcedureValue());
      }
    },
    'form.id_insurance'() {
      this.scheduleFetchResolvedProcedureValue();
    },
    'form.id_prof'() {
      this.scheduleFetchResolvedProcedureValue();
    },
    'form.id_spec'() {
      this.scheduleFetchResolvedProcedureValue();
    },
    'form.attendance_date'() {
      this.scheduleFetchResolvedProcedureValue();
    },
    providerSupplierId() {
      this.scheduleFetchResolvedProcedureValue();
    },
  },
  methods: {
    dateToString(date) {
      if (!date) return '';
      if (typeof date === 'string' && date.match(/^\d{4}-\d{2}-\d{2}$/)) {
        return date;
      }
      try {
        const d = date instanceof Date ? date : new Date(date);
        if (d instanceof Date && !isNaN(d.getTime())) {
          const y = d.getFullYear();
          const m = String(d.getMonth() + 1).padStart(2, '0');
          const day = String(d.getDate()).padStart(2, '0');
          return `${y}-${m}-${day}`;
        }
      } catch (e) {
      }
      return '';
    },
    formatDateToBR(dateString) {
      if (!dateString) return '';
      const parts = dateString.split('-');
      return parts.length === 3 ? `${parts[2]}/${parts[1]}/${parts[0]}` : '';
    },
    parseArray(value) {
      if (Array.isArray(value)) return value;
      if (typeof value === 'string') {
        try {
          return JSON.parse(value || '[]');
        } catch {
          return [];
        }
      }
      return [];
    },
    mapGuideProceduresToForm(guide) {
      if (Array.isArray(guide.procedures) && guide.procedures.length > 0) {
        return guide.procedures.map((p) => ({
          code: String(p.procedure_code ?? '').slice(0, 20),
          table_code: p.table_code || '22',
          description: p.description || null,
          execution_date: this.dateToString(p.execution_date),
          start_time: p.start_time || null,
          end_time: p.end_time || null,
          quantity: p.quantity ?? 1,
          unit_value: parseFloat(p.unit_value) || 0,
          unit_transfer_value: parseFloat(p.unit_transfer_value) || 0,
          reduction_factor: p.reduction_factor != null ? parseFloat(p.reduction_factor) : 1,
        }));
      }
      return this.parseArray(guide.executed_procedures).map((proc) => ({
        ...proc,
        code: String(proc.code ?? '').slice(0, 20),
        execution_date: this.dateToString(proc.execution_date),
        unit_transfer_value: proc.unit_transfer_value != null ? parseFloat(proc.unit_transfer_value) || 0 : 0,
      }));
    },
    async loadData(url, property, errorMessage) {
      try {
        const response = await http.get(url);
        this[property] = response.data || [];
      } catch (error) {
        console.error(errorMessage, error);
        this[property] = [];
      }
    },
    loadInsurances() {
      this.loadData(`/places/${this.place.id_place}/insurances`, 'insurances', 'Erro ao carregar convênios:');
    },
    async loadSuppliers() {
      this.suppliersLoaded = false;
      try {
        const response = await http.get(`/places/${this.place.id_place}/finances/suppliers`, {
          params: { active: true },
        });
        const list = response.data || [];
        this.suppliers = Array.isArray(list)
          ? list.filter((s) => s.active !== false)
          : [];
      } catch (error) {
        console.error('Erro ao carregar fornecedores:', error);
        this.suppliers = [];
      } finally {
        this.suppliersLoaded = true;
      }
    },
    loadCbos() {
      this.loadData('/cbos', 'cbos', 'Erro ao carregar CBOs:');
    },
    loadProfessionalCouncils() {
      this.loadData('/professional-councils', 'professionalCouncils', 'Erro ao carregar conselhos profissionais:');
    },
    loadAttendanceRegimes() {
      this.loadData('/attendance-regimes', 'attendanceRegimes', 'Erro ao carregar regimes de atendimento:');
    },
    loadConsultationTypes() {
      this.loadData(`/places/${this.place.id_place}/tiss-guides/consultation-types`, 'consultationTypes', 'Erro ao carregar tipos de consulta:');
    },
    loadAccidentIndicators() {
      this.loadData(`/places/${this.place.id_place}/tiss-guides/accident-indicators`, 'accidentIndicators', 'Erro ao carregar indicadores de acidente:');
    },
    loadStates() {
      this.loadData('/states', 'states', 'Erro ao carregar estados:');
    },
    async loadProviderCities() {
      if (!this.form.id_provider_state) {
        this.providerCities = [];
        return;
      }
      await this.loadData(`/states/${this.form.id_provider_state}/cities`, 'providerCities', 'Erro ao carregar cidades:');
    },
    loadSpecialties() {
      this.loadData(`/places/${this.place.id_place}/specialties`, 'specialties', 'Erro ao carregar especialidades:');
    },
    async searchZipcode() {
      if (!this.form.provider_zipcode) return;

      const zipcode = this.form.provider_zipcode.replace(/\D/g, '');
      if (zipcode.length !== 8) {
        Alert.toastWarning('CEP deve conter 8 dígitos');
        return;
      }

      this.loadingZipcode = true;
      try {
        const response = await http.get(`/zipcode/${zipcode}`);
        const data = response.data;

        if (data.address) this.form.provider_address = data.address;
        if (data.neighborhood) this.form.provider_neighborhood = data.neighborhood;
        
        if (data.state?.id_state) {
          this.form.id_provider_state = data.state.id_state;
          await this.loadProviderCities();
          if (data.city?.id_city) {
            this.form.id_provider_city = data.city.id_city;
          }
        } else if (data.city?.id_city) {
          this.form.id_provider_city = data.city.id_city;
        }

        Alert.toastSuccess('CEP encontrado e campos preenchidos!');
      } catch (error) {
        console.error('Erro ao buscar CEP:', error);
        Alert.toastError(error.response?.data?.error || 'CEP não encontrado');
      } finally {
        this.loadingZipcode = false;
      }
    },
    loadGuideData() {
      if (!this.guide || !this.guide.id_tiss_guide) {
        return;
      }

      this._suspendResolvedProcedureFetch = true;
      this.form = {
        guide_type: this.guide.guide_type || '',
        id_patient: this.guide.id_patient,
        patient_name: this.guide.patient?.patient_name || '',
        id_prof: this.guide.id_prof,
        id_insurance: this.guide.id_insurance,
        operator_guide_number: this.guide.operator_guide_number || '',
        patient_cpf: this.guide.patient_cpf || '',
        patient_birth_date: this.dateToString(this.guide.patient_birth_date),
        patient_cns: this.guide.patient_cns || '',
         attendance_date: this.dateToString(this.guide.attendance_date),
         procedure_code: String(this.guide.procedure_code || this.defaultProcedureCode).slice(0, 20),
         procedure_table: this.guide.procedure_table || '22',
         procedure_value: this.guide.procedure_value ? parseFloat(this.guide.procedure_value) : 0,
         procedure_transfer_value: this.guide.procedure_transfer_value != null && this.guide.procedure_transfer_value !== ''
           ? parseFloat(this.guide.procedure_transfer_value)
           : 0,
        id_spec: this.guide.id_spec || null,
        emission_date: this.dateToString(this.guide.emission_date) || this.dateToString(new Date()),
        observations: this.guide.observations || '',
        ans_registry: this.guide.ans_registry || '',
        plan_name: this.guide.plan_name || '',
        card_number: this.guide.card_number || '',
        card_validity_date: this.dateToString(this.guide.card_validity_date),
        patient_social_name: this.guide.patient_social_name || '',
        provider_document: this.guide.provider_document || '',
        provider_name: this.guide.provider_name || '',
        provider_address: this.guide.provider_address || '',
        provider_number: this.guide.provider_number || '',
        provider_complement: this.guide.provider_complement || '',
        provider_neighborhood: this.guide.provider_neighborhood || '',
        id_provider_city: this.guide.id_provider_city || null,
        id_provider_state: this.guide.id_provider_state || null,
        provider_zipcode: this.guide.provider_zipcode || '',
        cnes: this.guide.cnes || '',
        professional_name: this.guide.professional_name || '',
        professional_council: this.guide.professional_council || '',
        professional_council_number: this.guide.professional_council_number || '',
        professional_council_state: this.guide.professional_council_state || '',
        professional_cbo: this.guide.professional_cbo || '',
        consultation_type: this.guide.consultation_type || '1',
        accident_indicator: this.guide.accident_indicator || '9',
        newborn_care: this.guide.newborn_care || 'N',
        special_coverage: this.guide.special_coverage || '',
        attendance_regime: this.guide.attendance_regime || '01',
        occupational_health: this.guide.occupational_health || '',
        authorization_number: this.guide.authorization_number || '',
        authorization_password: this.guide.authorization_password || '',
        authorization_validity: this.dateToString(this.guide.authorization_validity),
        requester_professional_name: this.guide.requester_professional_name || '',
        requester_professional_council: this.guide.requester_professional_council || '',
        requester_professional_cbo: this.guide.requester_professional_cbo || '',
        requester_provider_code: this.guide.requester_provider_code || '',
        requester_provider_name: this.guide.requester_provider_name || '',
        request_date: this.dateToString(this.guide.request_date) || (this.guide.guide_type === 'SP_SADT' ? this.dateToString(new Date()) : ''),
        clinical_indication: this.guide.clinical_indication || '',
        executed_procedures: this.mapGuideProceduresToForm(this.guide),
        other_expenses: this.parseArray(this.guide.other_expenses).map(exp => ({
          ...exp,
          execution_date: this.dateToString(exp.execution_date)
        })),
      };

      if (this.guide.id_prof) {
        this.loadProfessionalSpecialties();
      }
      if (this.guide.id_provider_state) {
        this.loadProviderCities();
      }
      this.resetExpandedSections();
      this.$nextTick(async () => {
        try {
          await this.loadSuppliers();
          this.syncProviderSupplierIdFromForm();
          await this.syncExecutingProfessionalSupplierFromProfPlace();
        } finally {
          this._suspendResolvedProcedureFetch = false;
        }
      });
    },
    resetForm() {
      this.providerSupplierId = null;
      if (this._resolveProcedureDebounce) {
        clearTimeout(this._resolveProcedureDebounce);
        this._resolveProcedureDebounce = null;
      }
      this.form = {
        guide_type: '',
        id_patient: null,
        patient_name: '',
        id_prof: null,
        id_insurance: null,
        operator_guide_number: '',
        patient_cpf: '',
        patient_birth_date: '',
        patient_cns: '',
        attendance_date: this.dateToString(new Date()),
        procedure_code: this.defaultProcedureCode,
        procedure_table: '22',
        procedure_value: 0,
        procedure_transfer_value: 0,
        id_spec: null,
        emission_date: this.dateToString(new Date()),
        observations: '',
        ans_registry: '',
        plan_name: '',
        card_number: '',
        card_validity_date: '',
        patient_social_name: '',
        provider_document: '',
        provider_name: '',
        provider_address: '',
        provider_number: '',
        provider_complement: '',
        provider_neighborhood: '',
        id_provider_city: null,
        id_provider_state: null,
        provider_zipcode: '',
        cnes: '',
        professional_name: '',
        professional_council: '',
        professional_council_number: '',
        professional_council_state: '',
        professional_cbo: '',
        consultation_type: '1',
        accident_indicator: '9',
        newborn_care: 'N',
        special_coverage: '',
        attendance_regime: '01',
        occupational_health: '',
        authorization_number: '',
        authorization_password: '',
        authorization_validity: '',
        requester_professional_name: '',
        requester_professional_council: '',
        requester_professional_cbo: '',
        requester_provider_code: '',
        requester_provider_name: '',
        request_date: '',
        clinical_indication: '',
        executed_procedures: [],
        other_expenses: [],
      };
      this.resetExpandedSections();
    },
    syncProviderSupplierIdFromForm() {
      if (!this.suppliers.length) {
        this.providerSupplierId = null;
        return;
      }
      const doc = (this.form.provider_document || '').replace(/\D/g, '');
      const name = (this.form.provider_name || '').trim().toLowerCase();
      if (!doc && !name) {
        this.providerSupplierId = null;
        return;
      }
      const match = this.suppliers.find((s) => {
        const sdoc = String(s.document || '').replace(/\D/g, '');
        if (doc.length >= 11 && sdoc === doc) {
          return true;
        }
        const sname = (s.name || '').trim().toLowerCase();
        return Boolean(name && sname === name);
      });
      this.providerSupplierId = match ? match.id : null;
    },
    async onProviderSupplierChange() {
      if (this.providerSupplierId == null) {
        return;
      }
      const supplier = this.suppliers.find((s) => s.id === this.providerSupplierId);
      if (!supplier) {
        return;
      }
      this.form.provider_document = supplier.document || '';
      this.form.provider_name = supplier.name || '';
      this.form.provider_zipcode = supplier.zipcode || '';
      this.form.provider_address = supplier.street || '';
      this.form.provider_number = supplier.number || '';
      this.form.provider_complement = supplier.complement || '';
      this.form.provider_neighborhood = supplier.neighborhood || '';
      this.form.id_provider_state = supplier.state_id || null;
      await this.loadProviderCities();
      this.form.id_provider_city = supplier.city_id || null;
    },
    resetExpandedSections() {
      this.expandedSections = {
        patientDetails: false,
        insuranceDetails: false,
        requesterDetails: false,
        professionalDetails: false,
        providerDetails: false,
        procedureDetails: false,
        consultationDetails: false,
      };
    },
    onClickSearchedPatient(patient) {
      if (patient) {
        this.form.id_patient = patient.id_patient;
        this.form.patient_name = patient.patient_name || '';

        if (patient.patient_cpf) {
          this.form.patient_cpf = patient.patient_cpf;
        }
        if (patient.patient_birthdate) {
          this.form.patient_birth_date = this.dateToString(patient.patient_birthdate);
        }
        if (patient.patient_cns) {
          this.form.patient_cns = patient.patient_cns;
        }

        const selectedInsuranceId = patient.id_insurance_plan_dependent
          || patient.id_insurance_active
          || patient.id_insurance_last;

        const insuranceMatch = this.insurances.find((insurance) => insurance.id_insurance == selectedInsuranceId);
        if (selectedInsuranceId && insuranceMatch) {
          this.form.id_insurance = insuranceMatch.id_insurance;
          this.onInsuranceChange();

          const rawInsuranceData = patient.plan_dependent_insurance_data ?? patient.insurance_data;
          if (rawInsuranceData) {
            const insuranceData = typeof rawInsuranceData === 'string'
              ? JSON.parse(rawInsuranceData)
              : rawInsuranceData;

            if (insuranceData.card_number) {
              this.form.card_number = insuranceData.card_number;
            }
            if (insuranceData.plan_name) {
              this.form.plan_name = insuranceData.plan_name;
            }
            if (insuranceData.code_ans) {
              this.form.ans_registry = insuranceData.code_ans;
            }
            if (insuranceData.valid_until) {
              this.form.card_validity_date = this.dateToString(insuranceData.valid_until);
            }
          }
        }
      }
    },
    openModalEditPatient() {
      if (!this.place?.id_place || !this.currentPatientId) return;

      http.get(`/places/${this.place.id_place}/patients/${this.currentPatientId}`)
        .then((response) => {
          Modal.hide('#TissGuideModal');
          this.$nextTick(() => {
            this.currentPatientData = response.data;
            this.isEditPatientModalOpen = true;
          });
        })
        .catch((e) => {
          Alert.toastError(e.response?.data?.message ?? e.response?.data ?? 'Erro ao carregar paciente.');
        });
    },
    onCloseModalEditPatient() {
      this.isEditPatientModalOpen = false;
      this.currentPatientData = null;

      const el = document.querySelector('#TissGuideModal');
      if (el) {
        bootstrap.Modal.getOrCreateInstance(el).show();
      }
    },
    onPatientUpdated() {
      if (!this.place?.id_place || !this.currentPatientId) return;

      http.get(`/places/${this.place.id_place}/patients/${this.currentPatientId}`)
        .then((response) => {
          const p = response.data;
          this.form.patient_name = p.patient_name ?? this.form.patient_name;
          this.form.patient_cpf = p.patient_cpf ?? this.form.patient_cpf;
          this.form.patient_birth_date = p.patient_birthdate
            ? this.dateToString(p.patient_birthdate)
            : this.form.patient_birth_date;
          this.form.patient_cns = p.patient_cns ?? this.form.patient_cns;
        })
        .catch(() => {
          // Se falhar ao atualizar, mantemos os dados atuais do formulário.
        });
    },
    onInsuranceChange() {
      if (this.form.id_insurance) {
        const insurance = this.insurances.find(i => i.id_insurance === this.form.id_insurance);
        if (insurance) {
          this.form.ans_registry = insurance.code_ans || '';
          this.form.plan_name = insurance.plan_name || '';
        }
      } else {
        this.form.ans_registry = '';
        this.form.plan_name = '';
      }
    },
    /**
     * Prestador executante: quando prof_place.id_supplier está definido para o profissional neste local,
     * seleciona o fornecedor correspondente e preenche os dados do prestador a partir do cadastro financeiro.
     */
    async syncExecutingProfessionalSupplierFromProfPlace() {
      if (!this.form.id_prof) {
        return;
      }
      const professional = this.professionals.find((p) => p.id_prof === this.form.id_prof);

      const rawId = professional && professional.id_supplier != null ? professional.id_supplier : null;
      if (rawId === null || rawId === '' || rawId === undefined) {
        return;
      }
      const supplierId = Number(rawId);

      if (!Number.isFinite(supplierId) || supplierId <= 0) {
        return;
      }
      if (!this.suppliers.length) {
        await this.loadSuppliers();
      }
      const supplier = this.suppliers.find((s) => Number(s.id) === supplierId);
      if (!supplier) {
        return;
      }
      this.providerSupplierId = supplierId;
      await this.onProviderSupplierChange();
    },
    async onProfessionalChange() {
      if (this.form.id_prof) {
        const professional = this.professionals.find(p => p.id_prof === this.form.id_prof);
        if (professional) {
          this.form.professional_name = professional.prof_name || '';

          if (professional.provider_document) {
            this.form.provider_document = professional.provider_document;
          }
          if (professional.provider_name) {
            this.form.provider_name = professional.provider_name;
          }
          if (professional.provider_address) {
            this.form.provider_address = professional.provider_address;
          }
          if (professional.provider_number) {
            this.form.provider_number = professional.provider_number;
          }
          if (professional.provider_complement) {
            this.form.provider_complement = professional.provider_complement;
          }
          if (professional.provider_neighborhood) {
            this.form.provider_neighborhood = professional.provider_neighborhood;
          }
          if (professional.id_provider_city) {
            this.form.id_provider_city = professional.id_provider_city;
            if (professional.id_provider_state) {
              this.form.id_provider_state = professional.id_provider_state;
              this.loadProviderCities();
            }
          } else if (professional.id_provider_state) {
            this.form.id_provider_state = professional.id_provider_state;
            this.loadProviderCities();
          }
          if (professional.provider_zipcode) {
            this.form.provider_zipcode = professional.provider_zipcode;
          }
          if (professional.cnes) {
            this.form.cnes = professional.cnes;
          }
        }

        // Carrega especialidades e preenche conselho a partir da especialidade (kind_acronym/UF/CBO/número).
        this.form.id_spec = null;
        await this.loadProfessionalSpecialties();
        await this.syncExecutingProfessionalSupplierFromProfPlace();
      } else {
        this.form.professional_name = '';
        this.form.professional_council = '';
        this.form.professional_council_number = '';
        this.form.professional_council_state = '';
        this.form.professional_cbo = '';
        this.form.id_spec = null;
        this.professionalSpecialties = [];
      }
    },
    onRequesterProfessionalChange() {
      if (this.form.requester_professional_id) {
        this.form.requester_professional_council = '';
        this.form.requester_professional_cbo = '';
        const professional = this.professionals.find(p => p.id_prof === this.form.requester_professional_id);
        if (professional) {
          this.form.requester_professional_name = professional.prof_name || '';
        }
        this.form.requester_id_spec = null;
        this.requesterProfessionalSpecialties = [];
        this.$nextTick(() => {
          this.applyRequesterCouncilAndCboFromProfessional();
        });
        this.loadRequesterProfessionalSpecialties();
      } else {
        this.form.requester_professional_name = '';
        this.form.requester_professional_council = '';
        this.form.requester_professional_cbo = '';
        this.form.requester_id_spec = null;
        this.requesterProfessionalSpecialties = [];
      }
    },
    async loadRequesterProfessionalSpecialties() {
      if (!this.form.requester_professional_id) {
        this.requesterProfessionalSpecialties = [];
        this.form.requester_id_spec = null;
        return;
      }
      await this.loadData(
        `/professionals/${this.form.requester_professional_id}/specialties`,
        'requesterProfessionalSpecialties',
        'Erro ao carregar especialidades do profissional solicitante:'
      );

      if (this.requesterProfessionalSpecialties &&
        this.requesterProfessionalSpecialties.length > 0 &&
        !this.form.requester_id_spec
      ) {
        this.form.requester_id_spec = this.requesterProfessionalSpecialties[0].id_spec;
        this.$nextTick(() => {
          this.onRequesterSpecialtyChange();
        });
      } else if (!this.requesterProfessionalSpecialties?.length) {
        this.$nextTick(() => {
          this.applyRequesterCouncilAndCboFromProfessional();
        });
      }
    },
    onRequesterSpecialtyChange() {
      if (!this.form.requester_id_spec || !this.form.requester_professional_id) {
        return;
      }

      const specialty = this.requesterProfessionalSpecialties.find(s => s.id_spec === this.form.requester_id_spec);

      if (specialty) {
        if (specialty.kind_acronym) {
          const council = this.professionalCouncils.find(c => c.code === specialty.kind_acronym);
          if (council) {
            this.form.requester_professional_council = council.code;
          } else {
            this.form.requester_professional_council = specialty.kind_acronym;
          }
        }
        if (specialty.prof_cbo) {
          this.form.requester_professional_cbo = specialty.prof_cbo;
        }
      }
    },
    applyRequesterCouncilAndCboFromProfessional() {
      if (!this.form.requester_professional_id) {
        return;
      }
      const professional = this.professionals.find(p => p.id_prof === this.form.requester_professional_id);
      if (!professional) {
        return;
      }
      if (professional.kind_acronym) {
        const council = this.professionalCouncils.find(c => c.code === professional.kind_acronym);
        this.form.requester_professional_council = council
          ? council.code
          : professional.kind_acronym;
      }
      if (professional.prof_cbo) {
        this.form.requester_professional_cbo = professional.prof_cbo;
      }
    },
    async loadProfessionalSpecialties() {
      if (!this.form.id_prof) {
        this.professionalSpecialties = [];
        this.form.id_spec = null;
        return;
      }
      await this.loadData(`/professionals/${this.form.id_prof}/specialties`, 'professionalSpecialties', 'Erro ao carregar especialidades do profissional:');
      
      // Seleciona automaticamente a primeira especialidade (se houver) e aplica o preenchimento do conselho.
      if (this.professionalSpecialties?.length > 0 && !this.form.id_spec) {
        this.form.id_spec = this.professionalSpecialties[0].id_spec;
      }

      this.onSpecialtyChange();
    },
    onSpecialtyChange() {
      if (!this.form.id_spec || !this.form.id_prof) {
        return;
      }

      const specialty = this.professionalSpecialties.find(s => s.id_spec === this.form.id_spec);

      if (specialty) {
        if (specialty.kind_acronym) {
          const council = this.professionalCouncils.find(c => c.code === specialty.kind_acronym);
          if (council) {
            this.form.professional_council = council.code;
          } else {
            this.form.professional_council = specialty.kind_acronym;
          }
        }
        if (specialty.prof_council) {
          this.form.professional_council_number = specialty.prof_council;
        }
        if (specialty.prof_cbo) {
          this.form.professional_cbo = specialty.prof_cbo;
        }
        if (specialty.prof_council_state) {
          this.form.professional_council_state = specialty.prof_council_state;
        }
      }
    },
    onProviderStateChange() {
      this.form.id_provider_city = null;
      this.loadProviderCities();
    },
    scheduleFetchResolvedProcedureValue() {
      if (this._suspendResolvedProcedureFetch) {
        return;
      }
      if (this._resolveProcedureDebounce) {
        clearTimeout(this._resolveProcedureDebounce);
      }
      this._resolveProcedureDebounce = setTimeout(() => {
        this._resolveProcedureDebounce = null;
        this.fetchResolvedProcedureValue();
      }, 300);
    },
    async fetchResolvedProcedureValue() {
      if (!this.show || this.form.guide_type !== 'CONSULTA') {
        return;
      }
      if (this._suspendResolvedProcedureFetch) {
        return;
      }
      if (!this.form.id_prof || !this.form.attendance_date) {
        return;
      }
      const params = {
        id_prof: this.form.id_prof,
        attendance_date: this.form.attendance_date,
      };
      if (this.form.id_spec) {
        params.id_spec = this.form.id_spec;
      }
      if (this.form.id_insurance) {
        params.id_insurance = this.form.id_insurance;
      }
      if (this.providerSupplierId != null) {
        params.id_supplier = this.providerSupplierId;
      }
      try {
        const response = await http.get(
          `/places/${this.place.id_place}/tiss-guides/resolved-procedure-value`,
          { params }
        );
        if (this._suspendResolvedProcedureFetch) {
          return;
        }
        const data = response.data || {};
        this._applyingProcedureSuggestion = true;
        if (data.resolved) {
          const v = parseFloat(data.procedure_value);
          if (!Number.isNaN(v)) {
            this.form.procedure_value = v;
          }
        }
        if (data.transfer_resolved) {
          const t = parseFloat(data.procedure_transfer_value);
          if (!Number.isNaN(t)) {
            this.form.procedure_transfer_value = t;
          }
        }
        this.$nextTick(() => {
          this._applyingProcedureSuggestion = false;
        });
      } catch (e) {
        console.error('Erro ao resolver valor do procedimento / repasse:', e);
      }
    },
    async fetchResolvedProcedureValueForProcedureForm() {
      if (!this.show || !this.place?.id_place || this.form.guide_type !== 'SP_SADT') {
        return;
      }
      if (!this.form.id_prof) {
        return;
      }
      const executionDate = String(this.procedureForm.execution_date || '').trim();
      const attendanceSource = executionDate.length > 0
        ? executionDate
        : (this.form.attendance_date || this.form.emission_date);
      const attendanceDate = this.dateToString(attendanceSource || new Date());
      if (!attendanceDate) {
        return;
      }

      const params = {
        id_prof: this.form.id_prof,
        attendance_date: attendanceDate,
      };
      const specId =
        this.procedureForm.catalog_spec_id != null && this.procedureForm.catalog_spec_id !== ''
          ? Number(this.procedureForm.catalog_spec_id)
          : null;
      if (specId !== null && !Number.isNaN(specId)) {
        params.id_spec = specId;
      }
      if (this.form.id_insurance) {
        params.id_insurance = this.form.id_insurance;
      }
      if (this.providerSupplierId != null) {
        params.id_supplier = this.providerSupplierId;
      }

      try {
        const response = await http.get(
          `/places/${this.place.id_place}/tiss-guides/resolved-procedure-value`,
          { params }
        );
        const data = response.data || {};

        if (data.resolved) {
          const v = parseFloat(data.procedure_value);
          if (!Number.isNaN(v)) {
            this.procedureForm.unit_value = v;
          }
        }
        if (data.transfer_resolved) {
          const t = parseFloat(data.procedure_transfer_value);
          if (!Number.isNaN(t)) {
            this.procedureForm.unit_transfer_value = t;
          }
        }
      } catch (e) {
        console.error('Erro ao resolver valores unitários do procedimento:', e);
      }
    },
    onGuideTypeChange() {
      if (this.form.guide_type === 'CONSULTA') {
        this.form.authorization_number = '';
        this.form.authorization_password = '';
        this.form.authorization_validity = null;
        this.form.requester_professional_id = null;
        this.form.requester_professional_name = '';
        this.form.requester_professional_council = '';
        this.form.requester_professional_cbo = '';
        this.form.requester_id_spec = null;
        this.form.requester_provider_code = '';
        this.form.requester_provider_name = '';
        this.form.request_date = null;
        this.form.clinical_indication = '';
        this.$nextTick(() => this.fetchResolvedProcedureValue());
      } else if (this.form.guide_type === 'SP_SADT') {
        this.form.consultation_type = '1';
        this.form.accident_indicator = 'N';
        this.form.request_date = this.dateToString(new Date());
      }
    },
    onUpdateAttachments(files) {
      this.spSadtAttachments = files || [];
    },
    async submitForm() {
      this.loading = true;
      try {
        const url = this.guide?.id_tiss_guide
          ? `/places/${this.place.id_place}/tiss-guides/${this.guide.id_tiss_guide}`
          : `/places/${this.place.id_place}/tiss-guides`;
        const method = this.guide?.id_tiss_guide ? 'put' : 'post';

        const payload = { ...this.form };
        if (this.providerSupplierId != null) {
          payload.id_supplier = this.providerSupplierId;
        }
        if (payload.procedure_code != null && payload.procedure_code !== '') {
          payload.procedure_code = String(payload.procedure_code).slice(0, 20);
        }
        if (this.form.guide_type === 'SP_SADT' && Array.isArray(this.form.executed_procedures)) {
          payload.procedures = this.form.executed_procedures.map((p) => ({
            procedure_code: String(p.code ?? '').slice(0, 20),
            table_code: p.table_code || '22',
            description: p.description || null,
            execution_date: p.execution_date || null,
            start_time: p.start_time || null,
            end_time: p.end_time || null,
            quantity: p.quantity ?? 1,
            unit_value: p.unit_value ?? 0,
            unit_transfer_value: p.unit_transfer_value ?? 0,
            reduction_factor: p.reduction_factor ?? null,
          }));
        }

        const response = await http[method](url, payload);
        const savedGuide = response.data;

        // Se guia SP/SADT e houver anexos selecionados, envia-os após salvar a guia
        if (!this.guide?.id_tiss_guide &&
          savedGuide?.id_tiss_guide &&
          this.form.guide_type === 'SP_SADT' &&
          Array.isArray(this.spSadtAttachments) &&
          this.spSadtAttachments.length > 0
        ) {
          const formData = new FormData();
          this.spSadtAttachments.forEach((file, index) => {
            formData.append(`files[${index}][file]`, file);
            formData.append(`files[${index}][name]`, file.name);
          });

          try {
            await http.post(
              `/places/${this.place.id_place}/tiss-guides/${savedGuide.id_tiss_guide}/files`,
              formData,
              { headers: { 'Content-Type': 'multipart/form-data' } }
            );
          } catch (e) {
            Alert.toastError(e.response?.data?.message || 'Erro ao enviar anexos da guia.');
          }
        }

        Alert.toastSuccess(this.guide?.id_tiss_guide ? 'Guia atualizada com sucesso!' : 'Guia criada com sucesso!');
        this.$emit('saved');

        // Perguntar sobre cobrança apenas na criação
        if (!this.guide?.id_tiss_guide && savedGuide?.id_tiss_guide) {
          await this.maybeCreateChargeForGuide(savedGuide);
        }

        this.closeModal();
      } catch (error) {
        Alert.toastError(error.response?.data?.message || 'Erro ao salvar guia');
      } finally {
        this.loading = false;
      }
    },
    closeModal() {
      Modal.toggle('#TissGuideModal');
      this.$emit('close');
    },
    openProcedureModal(index = null) {
      this.editingProcedureIndex = index;
      if (index !== null && this.form.executed_procedures[index]) {
        const proc = this.form.executed_procedures[index];
        this.procedureForm = {
          code: String(proc.code || '').slice(0, 20),
          table_code: proc.table_code || '',
          description: proc.description || '',
          execution_date: this.dateToString(proc.execution_date),
          start_time: proc.start_time || '',
          end_time: proc.end_time || '',
          quantity: proc.quantity || 1,
          unit_value: proc.unit_value || 0,
          unit_transfer_value: proc.unit_transfer_value ?? 0,
          reduction_factor: proc.reduction_factor || 1.0,
          catalog_spec_id: null,
        };
      } else {
        this.resetProcedureForm();
      }
      Modal.toggle('#ProcedureModal');
    },
    closeProcedureModal() {
      Modal.toggle('#ProcedureModal');
      this.resetProcedureForm();
      this.editingProcedureIndex = null;
      this.procedureModalDetailsExpanded = false;
    },
    resetProcedureForm() {
      this.procedureForm = {
        code: '',
        table_code: '22',
        description: '',
        execution_date: '',
        start_time: '',
        end_time: '',
        quantity: 1,
        unit_value: 0,
        unit_transfer_value: 0,
        reduction_factor: 1.0,
        catalog_spec_id: null,
      };
    },
    saveProcedure(continueAfter = false) {
      if (!this.procedureForm.code || !this.procedureForm.table_code || !this.procedureForm.description) {
        Alert.toastError('Preencha todos os campos obrigatórios do procedimento');
        return;
      }

      const transferRaw = this.procedureForm.unit_transfer_value;
      if (transferRaw === '' || transferRaw === null || Number.isNaN(Number(transferRaw))) {
        Alert.toastError('Informe o repasse unitário do procedimento');
        return;
      }
      if (Number(transferRaw) < 0) {
        Alert.toastError('O repasse unitário deve ser maior ou igual a zero');
        return;
      }

      const procedure = {
        code: String(this.procedureForm.code || '').slice(0, 20),
        table_code: this.procedureForm.table_code,
        description: this.procedureForm.description,
        execution_date: this.procedureForm.execution_date || '',
        start_time: this.procedureForm.start_time || '00:00:00',
        end_time: this.procedureForm.end_time || '00:00:00',
        quantity: this.procedureForm.quantity || 1,
        unit_value: this.procedureForm.unit_value || 0,
        unit_transfer_value: Number(transferRaw),
        reduction_factor: this.procedureForm.reduction_factor || 1.0,
      };

      if (!this.form.executed_procedures) {
        this.form.executed_procedures = [];
      }

      const wasEditingProcedure = this.editingProcedureIndex !== null;

      if (this.editingProcedureIndex !== null) {
        this.form.executed_procedures[this.editingProcedureIndex] = procedure;
      } else {
        this.form.executed_procedures.push(procedure);
      }

      if (continueAfter) {
        this.editingProcedureIndex = null;
        this.resetProcedureForm();
        Alert.toastSuccess(
          wasEditingProcedure
            ? 'Alterações salvas. Inclua outro procedimento ou feche o modal.'
            : 'Procedimento incluído. Inclua outro ou feche o modal.'
        );
      } else {
        this.closeProcedureModal();
      }
    },
    editProcedure(index) {
      this.openProcedureModal(index);
    },
    removeProcedure(index) {
      if (confirm('Tem certeza que deseja remover este procedimento?')) {
        this.form.executed_procedures.splice(index, 1);
      }
    },
    async onProcedureSelectInModal(proc) {
      this.procedureForm.code = String(proc.code ?? '').slice(0, 20);
      this.procedureForm.description = proc.description || '';
      const fromSelect = proc.id_spec ?? proc.raw?.id_spec;
      this.procedureForm.catalog_spec_id =
        fromSelect !== null && fromSelect !== undefined && fromSelect !== '' ? Number(fromSelect) : null;
      if (this.procedureForm.catalog_spec_id !== null && Number.isNaN(this.procedureForm.catalog_spec_id)) {
        this.procedureForm.catalog_spec_id = null;
      }

      await this.fetchResolvedProcedureValueForProcedureForm();
    },
    onProcedureFormCodeChange(value) {
      const next = value != null ? String(value).slice(0, 20) : '';
      this.procedureForm.code = next;
      this.procedureForm.catalog_spec_id = null;
    },
    getTotalProceduresValue() {
      return (this.form.executed_procedures || []).reduce((total, proc) => {
        return total + (proc.unit_value || 0) * (proc.quantity || 1) * (proc.reduction_factor || 1.0);
      }, 0);
    },
    openExpenseModal(index = null) {
      this.editingExpenseIndex = index;
      if (index !== null && this.form.other_expenses[index]) {
        const exp = this.form.other_expenses[index];
        this.expenseForm = {
          expense_code: exp.expense_code || '',
          execution_date: this.dateToString(exp.execution_date),
          start_time: exp.start_time || '',
          end_time: exp.end_time || '',
          table_code: exp.table_code || '',
          item_code: exp.item_code || '',
          item_description: exp.item_description || '',
          quantity: exp.quantity || 0,
          unit_measure: exp.unit_measure || '036',
          unit_value: exp.unit_value || 0,
          anvisa_registration: exp.anvisa_registration || '',
          manufacturer_reference: exp.manufacturer_reference || '',
        };
      } else {
        this.resetExpenseForm();
      }
      Modal.toggle('#ExpenseModal');
    },
    closeExpenseModal() {
      Modal.toggle('#ExpenseModal');
      this.resetExpenseForm();
      this.editingExpenseIndex = null;
    },
    resetExpenseForm() {
      this.expenseForm = {
        expense_code: '',
        execution_date: '',
        start_time: '',
        end_time: '',
        table_code: '22',
        item_code: '',
        item_description: '',
        quantity: 0,
        unit_measure: '036',
        unit_value: 0,
        anvisa_registration: '',
        manufacturer_reference: '',
      };
    },
    saveExpense(continueAfter = false) {
      if (!this.expenseForm.expense_code || !this.expenseForm.table_code || !this.expenseForm.item_code || !this.expenseForm.item_description) {
        Alert.toastError('Preencha todos os campos obrigatórios da despesa');
        return;
      }

      const expense = {
        expense_code: this.expenseForm.expense_code,
        execution_date: this.expenseForm.execution_date || '',
        start_time: this.expenseForm.start_time || '00:00:00',
        end_time: this.expenseForm.end_time || '00:00:00',
        table_code: this.expenseForm.table_code,
        item_code: this.expenseForm.item_code,
        item_description: this.expenseForm.item_description,
        quantity: this.expenseForm.quantity || 0,
        unit_measure: this.expenseForm.unit_measure || '036',
        unit_value: this.expenseForm.unit_value || 0,
        anvisa_registration: this.expenseForm.anvisa_registration || null,
        manufacturer_reference: this.expenseForm.manufacturer_reference || null,
      };

      if (!this.form.other_expenses) {
        this.form.other_expenses = [];
      }

      const wasEditingExpense = this.editingExpenseIndex !== null;

      if (this.editingExpenseIndex !== null) {
        this.form.other_expenses[this.editingExpenseIndex] = expense;
      } else {
        this.form.other_expenses.push(expense);
      }

      if (continueAfter) {
        this.editingExpenseIndex = null;
        this.resetExpenseForm();
        Alert.toastSuccess(
          wasEditingExpense
            ? 'Alterações salvas. Inclua outra despesa ou feche o modal.'
            : 'Despesa incluída. Inclua outra ou feche o modal.'
        );
      } else {
        this.closeExpenseModal();
      }
    },
    editExpense(index) {
      this.openExpenseModal(index);
    },
    removeExpense(index) {
      if (confirm('Tem certeza que deseja remover esta despesa?')) {
        this.form.other_expenses.splice(index, 1);
      }
    },
    getTotalExpensesValue() {
      return (this.form.other_expenses || []).reduce((total, exp) => {
        return total + (exp.unit_value || 0) * (exp.quantity || 0);
      }, 0);
    },
    getExpenseTypeLabel(code) {
      const labels = {
        '01': 'Diárias',
        '02': 'Medicamentos',
        '03': 'Materiais',
        '05': 'Taxas e Aluguéis',
        '07': 'Gases Medicinais',
        '08': 'Órteses, Próteses e Materiais Especiais',
      };
      return labels[code] || code;
    },
    formatCurrency(value) {
      return parseFloat(value || 0).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    async maybeCreateChargeForGuide(guide) {
      // Primeiro pergunta se haverá cobrança
      const chargeDecision = await Swal.fire({
        title: 'Haverá cobrança para esta guia?',
        text: 'Você pode gerar uma cobrança (Pix ou boleto) vinculada a esta guia.',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        confirmButtonColor: '#780f5a',
      });

      if (!chargeDecision.isConfirmed) {
        return;
      }

      const procedureValue = parseFloat(guide?.procedure_value ?? 0);
      if (!(procedureValue > 5)) {
        Alert.toastError('Para gerar cobrança, o valor da guia precisa ser maior que R$ 5,00.');
        return;
      }

      // Pergunta o método de cobrança
      const methodDecision = await Swal.fire({
        title: 'Como deseja cobrar?',
        icon: 'question',
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonText: 'Pix',
        denyButtonText: 'Boleto',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#780f5a',
      });

      let paymentMethod = null;
      if (methodDecision.isConfirmed) {
        paymentMethod = 'pix';
      } else if (methodDecision.isDenied) {
        paymentMethod = 'bank_slip';
      } else {
        return;
      }

      try {
        Loader.show('Gerando cobrança', 'Aguarde...');
        const response = await http.post(
          `/places/${this.place.id_place}/tiss-guides/${guide.id_tiss_guide}/charge`,
          { payment_method: paymentMethod }
        );

        const chargeData = response.data.charge;
        Alert.toastSuccess('Cobrança gerada com sucesso.');

        // Em vez de abrir automaticamente, exibe um modal pequeno com ações
        this.chargeActionsGuideId = guide.id_tiss_guide;
        this.chargeActionsChargeData = chargeData;
        this.$nextTick(() => {
          this.$refs.chargeActionsModal?.open();
        });
      } catch (e) {
        Alert.toastError(e.response?.data?.message || 'Erro ao gerar cobrança da guia.');
      } finally {
        Loader.close();
      }
    },
    onViewPixFromChargeActions() {
      if (!this.chargeActionsChargeData?.pix_code) {
        return;
      }
      this.pixModalData = {
        pix_code: this.chargeActionsChargeData.pix_code,
        qr_code_base64: toPixQrCodeDataUrl(this.chargeActionsChargeData.pix_qrcode_img),
        payment_id: this.chargeActionsChargeData.id_card_trans,
        expires_at: this.chargeActionsChargeData.expires_at,
      };

      this.$nextTick(() => {
        this.$refs.pixPaymentModal?.open();
      });
    },
  }
}
</script>

<style scoped>
.required::after {
  content: " *";
  color: red;
}
</style>

<style>
#TissGuideModal .modal-body {
  max-height: min(70vh, 600px);
  overflow-y: auto;
}

/* Evita cortar a lista do autocomplete (overflow dos modais Bootstrap) */
#ProcedureModal.modal {
  overflow-y: visible;
}

#ProcedureModal .modal-dialog,
#ProcedureModal .modal-content,
#ProcedureModal .modal-body {
  overflow: visible;
}
</style>
